import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=5d620a08&scoped=true&"
import script from "./not-found.vue?vue&type=script&lang=ts&"
export * from "./not-found.vue?vue&type=script&lang=ts&"
import style0 from "./not-found.vue?vue&type=style&index=0&id=5d620a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d620a08",
  null
  
)

export default component.exports